// EquipmentStatusCardStyles.js
export const cardStyle = {
    padding: '16px',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    backgroundColor: '#fff',
};

export const iconStyleGreen = {
    fontSize: 40,
    color: '#16A34A',
    marginBottom: '4px',
};

export const iconStyleOrange = {
    fontSize: 40,
    color: '#EA580C',
    marginBottom: '4px',
};

const iconStyleBlue = { ...iconStyleGreen, color: '#1976d2' }; // Blue for available
const iconStyleRed = { ...iconStyleGreen, color: '#d32f2f' };  // Red for not available
export const textStyles = {
    title: {
        fontWeight: 'bold',
        marginBottom: '8px',
        display: 'block',
        fontSize: '1.5rem',
        fontWeight: '600',
        color: '#111827'
    },
    count: {
        fontWeight: 'bold',
        display: 'block',
        color: 'text.primary',
    },
    labelActive: {
        fontWeight: 600,
        color: '#16A34A',
        display: 'block',
    },
    labelInactive: {
        fontWeight: 600,
        color: '#EA580C',
        display: 'block',
    },

    labelAvailable: {
        fontWeight: 600,
        color: '#1976d2',
        display: 'block',
    },
    labelNotAvailable: {
        fontWeight: 600,
        color: '#991B1B',
        display: 'block',
    },
};
